module.exports = __webpack_public_path__ + "media/images/icon/plan-icon-f3e17beefd8d570074154ca08a9f61ba.svg";